<template>
  <div>
    <section class="section">
      <div class="container">
        <h6
          class="title is-6 is-uppercase has-text-left has-text-primary"
          v-t="'Admin.stats_active_users_title'"
        ></h6>
        <div class="columns is-multiline">
          <div class="column">
            <div
              class="box notification has-background-deep-celurean has-text-white"
            >
              <p
                class="subtitle is-6 is-uppercase"
                v-t="'Admin.total_active_users'"
              ></p>
              <AuxTweeningNumber
                class="title"
                :value="activityStats.total"
              ></AuxTweeningNumber>
            </div>
          </div>
          <div class="column">
            <div
              class="box notification has-background-egg-blue has-text-white"
            >
              <p
                class="subtitle is-6 is-uppercase"
                v-t="'Admin.last_year_active_users'"
              ></p>
              <AuxTweeningNumber
                class="title"
                :value="+activityStats.year"
              ></AuxTweeningNumber>
            </div>
          </div>
          <div class="column">
            <div
              class="box notification has-background-atlantis has-text-white"
            >
              <p
                class="subtitle is-6 is-uppercase"
                v-t="'Admin.last_month_active_users'"
              ></p>
              <AuxTweeningNumber
                class="title"
                :value="+activityStats.month"
              ></AuxTweeningNumber>
            </div>
          </div>
          <div class="column">
            <div class="box notification has-background-pizazz has-text-white">
              <p
                class="subtitle is-6 is-uppercase"
                v-t="'Admin.last_week_active_users'"
              ></p>
              <AuxTweeningNumber
                class="title"
                :value="+activityStats.week"
              ></AuxTweeningNumber>
            </div>
          </div>
        </div>
      </div>
    </section>
    <admin-stats-capsule-downloads :downloadStats="downloadStats" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AuxTweeningNumber from '@/components/AuxTweeningNumber'
import AdminStatsCapsuleDownloads from '@/components/AdminStatsCapsuleDownloads'
import _ from 'underscore'
export default {
  mounted () {
    this.fetchDownloadStats().then(response => {
      this.downloadStats = response.data
    })
    this.fetchActivityStats().then(
      response => (this.activityStats = response.data)
    )

    /* data = {
       query: {
        action: 'downloadFile'
      },
      aggregate: [
        {
          $group: {
            _id: "$userId",
            files: { $push: "$item" }
          }
        }
      ]
    }; */

    // this.getStats({ data: data }).then(response => console.log(response.data))
  },
  data () {
    return {
      downloadStats: [],
      activityStats: {
        total: 0,
        year: 0,
        month: 0,
        week: 0
      }
    }
  },
  components: { AuxTweeningNumber, AdminStatsCapsuleDownloads },
  computed: {
    ...mapGetters(['formattedCapsules']),
    ...mapState({
      capsules: state => state.Api.capsules,
      totalCapsules: state => state.Api.capsules.length,
      availableDownloads: state => {
        if (!state.Api.capsules) return
        const downloadsGroupId = 3
        const s = _.chain(state.Api.capsules)
          .pluck('fields')
          .map(capsuleFields => {
            return _.where(capsuleFields, { group: downloadsGroupId })
          })
          .flatten()
          .pluck('values')
          .map(value => {
            return _.chain(value)
              .values()
              .flatten()
              .value()
          }, 0)
          .flatten()
          .reduce((memo, filesArray) => {
            return memo + _.values(filesArray).length
          }, 0)
          .value()
        return s
      }
    }),
    differentFiles: function () {
      return _.chain(this.downloadStats)
        .groupBy('objectId')
        .keys()
        .value().length
    },
    differentUsers: function () {
      return _.chain(this.downloadStats)
        .groupBy('userId')
        .keys()
        .value().length
    },
    averageDownloads: function () {
      return this.availableDownloads / this.totalCapsules
    },
    downloadsByCapsule: function () {
      return _.chain(this.downloadStats)
        .groupBy('objectId')
        .value()
    }
    /* filesInCapsule: function () {
      const filesFields = _.chain(this.capsules)
        .pluck('fields')
        .map(capsuleFields => {
          return _.where(capsuleFields, { group: 3 })
        })
        .map(value => {
          return _.chain(value)
            .pluck('values')
            .value()
        })
        .values()
        .value()
      return {}
    } */
  },
  methods: {
    ...mapActions(['fetchDownloadStats', 'fetchActivityStats'])
  }
}
</script>

<style scoped lang="sass">
.title
  margin: auto
/deep/ .section
 padding: 1.5rem

</style>
